import { render } from "./PrivacyPolicyBanner.vue?vue&type=template&id=4453df5a"
import script from "./PrivacyPolicyBanner.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__